<script lang="ts" setup>
const props = defineProps<{
    title?: string;
    size?: 'lg';
    tabs?: any[];
}>();

const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'ok'): void;
}>();

const activeTab = defineModel<number>('activeTab');

const dialogClasses = computed(() => ({
    'tox-dialog': true,
    'tox-dialog--width-lg': props.size === 'lg'
}));

const handleClose = (): void =>
{
    hide();
    emit('close');
};

const handleSubmit = (): void =>
{
    hide();
    emit('ok');
};

const visible = ref(false);
const show = (): void =>
{
    visible.value = true;
};
const hide = (): void =>
{
    visible.value = false;
};

defineExpose({
    show,
    hide
});
</script>

<template>
    <div v-if="visible" class="tox tox-silver-sink tox-tinymce-aux" style="position: relative">
        <div tabindex="-1" class="tox-dialog-wrap">
            <div class="tox-dialog-wrap__backdrop" @click="handleClose" />

            <div role="dialog" aria-modal="true" tabindex="-1" :class="dialogClasses" style="position: relative;">
                <div role="presentation" class="tox-dialog__header">
                    <div class="tox-dialog__title">
                        {{ title }}
                    </div>

                    <button
                        type="button"
                        :aria-label="$t('[[[Zamknij]]]')"
                        :title="$t('[[[Zamknij]]]')"
                        tabindex="-1"
                        data-alloy-tabstop="true"
                        class="tox-button tox-button--icon tox-button--naked"
                        @click="handleClose"
                    >
                        <span class="tox-icon">
                            <svg width="24" height="24" focusable="false">
                                <path d="M17.3 8.2 13.4 12l3.9 3.8a1 1 0 0 1-1.5 1.5L12 13.4l-3.8 3.9a1 1 0 0 1-1.5-1.5l3.9-3.8-3.9-3.8a1 1 0 0 1 1.5-1.5l3.8 3.9 3.8-3.9a1 1 0 0 1 1.5 1.5Z" fill-rule="evenodd" />
                            </svg>
                        </span>
                    </button>
                </div>

                <div class="tox-dialog__content-js" style="overflow: auto;">
                    <div class="tox-dialog__body">
                        <!-- Tabs -->
                        <div v-if="tabs" role="tablist" data-alloy-tabstop="true" class="tox-dialog__body-nav">
                            <div
                                v-for="(tab, index) in tabs"
                                :key="index"
                                role="tab"
                                class="tox-dialog__body-nav-item tox-tab"
                                :class="{ 'tox-dialog__body-nav-item--active': activeTab === tab.id }"
                                @click="activeTab = tab.id"
                            >
                                <!-- {{ tab.datetime.replace("T", " ") }} -->
                                {{ tab.datetime.replace('T', ' ') || `Element ${tab.id}` }}
                            </div>
                        </div>

                        <!-- Content -->
                        <div class="tox-dialog__body-content">
                            <div class="tox-form">
                                <slot />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tox-dialog__footer">
                    <div role="presentation" class="tox-dialog__footer-start">
                        <slot name="prepend-footer" />
                    </div>

                    <div role="presentation" class="tox-dialog__footer-end">
                        <slot name="append-footer" />
                        <button
                            :title="$t('[[[Anuluj]]]')"
                            type="button"
                            tabindex="-1"
                            data-alloy-tabstop="true"
                            class="tox-button tox-button--secondary"
                            @click="handleClose"
                        >
                            {{ $t('[[[Anuluj]]]') }}
                        </button>
                        <button
                            :title="$t('[[[Zapisz]]]')"
                            type="button"
                            tabindex="-1"
                            data-alloy-tabstop="true"
                            class="tox-button"
                            @click="handleSubmit"
                        >
                            {{ $t('[[[Zapisz]]]') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
